import { RouterModule, Routes } from '@angular/router';

import { AuthUserService } from './services/auth-user-service/auth-user.service';

import { AuthzoneComponent } from './authzone/authzone.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { VehiclesComponent } from './vehicles/veh.component';
import { LicensesComponent } from './licenses/licenses.component';
import { InsurancesComponent } from './insurances/insurances.component';
import { AccidentsComponent } from './accidents/accidents.component';
import { InspectionsComponent } from './inspection/insp.component';
import { OwnersComponent } from './owners/owners.component';
import { BusStopsComponent } from './busstops/busstops.component';
import { ManageUsersComponent } from './manage-users/manage-users.component';

const routes: Routes = [
  {path: 'login', component: LoginComponent
    },
  { path: '', component: AuthzoneComponent, canActivate: [AuthUserService],
    children : [
      {path: 'dashboard', component: DashboardComponent},
      {path: 'users', component: ManageUsersComponent},
      {path: 'vehicles/:id', component: VehiclesComponent },
      {path: 'vehicles', component: VehiclesComponent},
      {path: 'vehiclesinv/:id', component: VehiclesComponent },
      {path: 'accidents/:id', component: AccidentsComponent },
      {path: 'accidents', component: AccidentsComponent},
      {path: 'licenses/:id', component: LicensesComponent },
      {path: 'licenses', component: LicensesComponent},
      {path: 'insurances/:id', component: InsurancesComponent },
      {path: 'insurances', component: InsurancesComponent},
      {path: 'owners/:id', component: OwnersComponent },
      {path: 'owners', component: OwnersComponent},
      {path: 'busstops', component: BusStopsComponent},
      {path: 'inspections/:id', component: InspectionsComponent },
      {path: 'inspections', component: InspectionsComponent},
      {path: '', redirectTo: '/login', pathMatch: 'full'}
    ]},
];

export const appRoutingProviders: any[] = [];
export const routing = RouterModule.forRoot(routes,{useHash: true});